// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"we_a bhs_b bhs_we"};